import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

import moment from 'moment-timezone';

import { InfoboxComponent } from '@recruitee/components/infobox';
import { I18nService, TranslatePipe } from '@recruitee/i18n';

@Component({
  selector: 'rt-company-deletion',
  templateUrl: './company-deletion.component.html',
  styleUrls: ['./company-deletion.component.less'],
  standalone: true,
  imports: [InfoboxComponent, TranslatePipe],
})
export class CompanyDeletionComponent {
  @Input() public adminName: string;
  @Input() public companyName: string;
  @Input() public loaded: boolean = false;
  @Input() public mode: 'long' | 'short' = 'long';
  @Input() public requestedAt: string;

  @Output() public supportClick: EventEmitter<void> = new EventEmitter();

  public message: string;

  private remainingDays: number;
  private readonly DAYS_LIMIT: number = 14;

  constructor(private i18n: I18nService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.loaded && changes.loaded.currentValue) {
      this.remainingDays = this.calculateRemainingDays();
      this.message = this.prepareMessage();
    }
  }

  private prepareMessage(mode = this.mode, remainingDays = this.remainingDays): string {
    return mode === 'long'
      ? this.i18n.translate('app.settings.delete_company.info_message', {
          count: remainingDays,
          companyName: this.companyName,
          adminName: this.adminName,
        })
      : this.i18n.translate('app.settings.delete_company.info_message_short', {
          count: remainingDays,
          companyName: this.companyName,
        });
  }

  private calculateRemainingDays(
    requestedAt: string = this.requestedAt,
    limit: number = this.DAYS_LIMIT,
  ): number {
    const today = moment().startOf('day');
    const deletionDate: moment.Moment = moment(requestedAt).add(limit, 'days').startOf('day');
    const daysRemaining: number = deletionDate.diff(today, 'days');
    return daysRemaining > 0 ? daysRemaining : 0;
  }
}
